/** Only the provider's own fixed authorize route can continue after Files login. */
export function loginDestination(search:string):string{
  const params=new URLSearchParams(search),next=params.get('next');
  if(params.getAll('next').length===1&&next&&next.length<=2048&&next.startsWith('/chat/authorize?')){
    try{const u=new URL(next,'https://ostart.invalid'),q=u.searchParams;
      if(u.origin==='https://ostart.invalid'&&u.pathname==='/chat/authorize'&&!u.hash&&[...q].length===3&&[...q.keys()].sort().join(',')==='code_challenge,code_challenge_method,state'&&q.get('code_challenge_method')==='S256'&&/^[A-Za-z0-9_-]{43}$/.test(q.get('state')??'')&&/^[A-Za-z0-9_-]{43}$/.test(q.get('code_challenge')??''))return u.pathname+u.search;
    }catch{/* Invalid continuation returns to the dashboard. */}
  }
  if(next&&next.length<=2048&&next.startsWith('/files/authorize?')){
    try{const url=new URL(next,'https://ostart.invalid');
      if(url.origin==='https://ostart.invalid'&&url.pathname==='/files/authorize'&&!url.hash)return url.pathname+url.search;
    }catch{/* Fall through to the existing login destination. */}
  }
  return params.get('mail')==='1'?'/mail/open':'/dashboard';
}
